// 获取API
import { getportalModules, getEduAdvertisingPics } from '@/api/user';
const advMoudel = {
  state: {
    advList: [],
    moudelsList: [],
    activeNameTag: 'iframeindex0'
  },

  mutations: {
    SET_ACTIVENAMETAG: (state, val) => {
      state.activeNameTag = val;
    },
    SET_ADVLIST: (state, advList) => {
      state.advList = advList;
      state.advList.forEach(element => {
        state.advList[element.advertisingLabel] = { list: [], showType: '', showStatus: '', adType: '' };
        state.advList[element.advertisingLabel].list = element.picList;
        state.advList[element.advertisingLabel].showType = element.showType; // 展现方式
        state.advList[element.advertisingLabel].showStatus = element.showStatus;// 展现与否
        state.advList[element.advertisingLabel].adType = element.adType;// 广告类型
      });
    },
    SET_MOUDLELIST: (state, moudelsList) => {
      state.moudelsList = moudelsList;
      state.moudelsList.forEach(element => {
        state.moudelsList[element.location] = { list: [], showType: '', moduleType: '', url: '', imgUrl: '', title: '' };
        // element.subResource.map(v => {
        //   if (v.moduleCode && v.moduleCode.indexOf('kqedu') > -1) {
        //     v.moduleCode = v.moduleCode.replace('http://kqedu.net', 'http://192.168.78.98:8080/');
        //     return v;
        //   }
        //   if (v.moduleUrl && v.moduleUrl.indexOf('kqedu') > -1) {
        //     v.moduleUrl = v.moduleUrl.replace('http://kqedu.net', 'http://192.168.78.98:8080/');
        //     return v;
        //   }
        // });
        state.moudelsList[element.location].list = element.subResource;
        state.moudelsList[element.location].showType = element.showType;
        state.moudelsList[element.location].moduleType = element.moduleType;
        state.moudelsList[element.location].url = element.url;
        state.moudelsList[element.location].imgUrl = element.imgUrl;
        state.moudelsList[element.location].title = element.title;
      });
    }
  },
  actions: {
    // 广告
    getadvList({ commit }) {
      return new Promise(() => {
        getEduAdvertisingPics().then(res => {
          if (res.data && res.data.length > 0) {
            commit('SET_ADVLIST', res.data);
          }
        });
      });
    },
    // 模块
    getModules({ commit }) {
      return new Promise(() => {
        getportalModules().then(res => {
          if (res.data && res.data.length > 0) {
            commit('SET_MOUDLELIST', res.data);
          }
        });
      });
    }
  }
};

export default advMoudel;
